import Vue from 'vue'

const requireComponent = require.context('.', true, /[\w-]+\.ts$/)

requireComponent.keys().forEach(fileName => {
  if (fileName !== './index.ts') {
    // Get directive name
    const directiveName = fileName
      .replace(/\.\w+$/, '')
      .split('/')
      .pop()
    // Get directive path
    const directive = requireComponent(fileName)

    // Globally register the directive
    Vue.directive(directiveName || '', directive.default)
  }
})
